import { JsonObject, JsonProperty, OnDeserialized } from "ta-json";

import type { Nullable } from "../../base-types";
import { RelationRole } from "../base/relation-role";

/**
 * Specifies a relation.
 */
export interface IRelationSpecification {
    /**
     * Name of the relation (case insensitive).
     */
    name: string;

    /**
     * If the relation is self-referencing, which role to load.
     * If it is null, both will be loaded into two separate relation objects.
     */
    role: Nullable<RelationRole>;

    /**
     * Creates a deep clone of this instance.
     */
    deepClone(): IRelationSpecification;

    /**
     * Checks if the current is the equal to other.
     * @param other - The instance to compare with
     */
    deepEquals(other: IRelationSpecification): boolean;
}

@JsonObject()
export class RelationSpecification implements IRelationSpecification {
    @JsonProperty("name")
    name: string;

    @JsonProperty("role")
    role: Nullable<RelationRole> = null;

    constructor(name: string, role?: Nullable<RelationRole>) {
        this.name = name;
        this.role = role ?? null;
    }

    deepClone(): IRelationSpecification {
        return new RelationSpecification(this.name, this.role);
    }

    deepEquals(other: IRelationSpecification): boolean {
        if (!other) return false;

        return other.name === this.name && ((!other.role && !this.role) || other.role === this.role);
    }

    @OnDeserialized()
    private onDeserialized(): void {
        this.role = this.role ?? null;
    }
}
